import { render, staticRenderFns } from "./OperaShopLabelsWindow.vue?vue&type=template&id=2841c45c&scoped=true&"
import script from "./OperaShopLabelsWindow.vue?vue&type=script&lang=js&"
export * from "./OperaShopLabelsWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaShopLabelsWindow.vue?vue&type=style&index=0&id=2841c45c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2841c45c",
  null
  
)

export default component.exports